module.exports = __webpack_public_path__ + "41809bc65fcbaef97c053c4b84ae3580.jpg";